import {Component, h, JSX, Listen, State, Prop, Host, Element} from '@stencil/core';

@Component({
    tag: 'oebbx-language-nav',
    styleUrl: 'language-nav.scss',
    shadow: false
})
export class OebbLanguageNav {

    @Element() el: HTMLElement;

    @Prop() buttonLabel: string;

    @Prop() activeLanguage: string;

    @State() isOpen = false;



    @Listen('keyup', {target: 'window'})
    handleKeyUp(e: KeyboardEvent) {
        if (!this.isOpen) return;

        if (e.key == 'Escape') {
            this.toggleLangNav();
        }
    }

    @Listen('focusout', { capture: true })
    handleFocusOut(e: FocusEvent) {
        if (!this.isOpen) { return; }

        const newFocusedElement = e.relatedTarget as HTMLElement | null;

        if (!newFocusedElement || !this.el.contains(newFocusedElement)) {
            this.toggleLangNav();
        }
    }

    @Listen('click', {target: 'window'})
    handleBodyClick(e: MouseEvent) {
        if (!this.isOpen) { return; }

        if (e.composedPath().includes(this.el)) {
            return;
        }

        this.toggleLangNav();
    }

    private handleButtonClick = () => {
        this.toggleLangNav();
    }

    private toggleLangNav = () => {
        this.isOpen = !this.isOpen
    }


    render(): JSX.Element {
        return (
            <Host class={{
                'language-nav-open': this.isOpen
            }}>
                <div class="language-nav__wrapper">
                    <button class="language-nav__toggler" onClick={this.handleButtonClick}>
                        {this.buttonLabel && (<span class="screen-reader-text">{this.buttonLabel}</span>)}
                        <oebb-globe-icon aria-hidden="true" height={16} />
                        <oebb-arrow-down-icon aria-hidden="true" />
                    </button>
                    <slot />
                </div>
                <span class="langauge-nav__active-lang">{this.activeLanguage}</span>
            </Host>
        );
    }
}
